import React from 'react'
import Select from 'react-select'
import moment from 'moment'
import DatePicker from 'react-datepicker'
import { fnum, sortOpts, getChanges } from '../../utils/utils'
import DeleteConfirmation from '../ui/DeleteConfirmation'
import Form from '../ui/Form'

export default class PRSEditPmntForm extends Form {

  constructor(props){
    super(props);
    this.state = {
      data: this.props.data,
      delConf: false,
      errors: {}
    };
  }

  savePost = (e) => {
    e.preventDefault();
    const oldD = this.props.data;
    const { data } = this.state;
    const toSend = getChanges(data, oldD);
    if(!Object.keys(toSend).length) {
      this.props.cancelEdit();
    }
    else {
      toSend.post_id = data.post_id;
      this.props.editPost(toSend, err => {
        if (err) {
          this.setState({errors: err});
          return;
        }
        this.props.cancelEdit();
        const diff = (
          oldD.post_price*oldD.post_qntt*oldD.post_payed -
          data.post_price*data.post_qntt*data.post_payed
        ) ;
        if(this.props.orderPayment) {
          this.props.updtBlnc(0, diff, 0);
        }
        else {
          this.props.updtBlnc(0, 0, diff);
        }
      });
    }
  }

  deletePost = (e) => {
    e.preventDefault();
    const oldD = this.props.data;
    this.props.editPost({
      post_id: oldD.post_id,
      post_active: 0
    }, err => {
      if (err) {
        this.setState({errors: err});
        return;
      }
      this.props.cancelEdit();
      const diff = oldD.post_price * oldD.post_qntt * oldD.post_payed;
      if(this.props.orderPayment) {
        this.props.updtBlnc(0, diff, 0);
      }
      else {
        this.props.updtBlnc(0, 0, diff);
      }
    });
  }

  updateLink = e => {
    this.setState({
      data:{
        ...this.state.data,
        post_seller: e.seller,
        post_link: e.value
      }
    });
  }

  payedToday = () => {
    this.setState({
      data:{
        ...this.state.data,
        post_bdate: moment().format('Y-MM-DD'),
        post_payed: 1
      }
    });
  }

  render() {
    const { srvcs, pmntLinkOptions } = this.props;

    const { data, errors } = this.state;

    const delConf = this.state.delConf ?
      <DeleteConfirmation
        onDelete={this.deletePost}
        onCancel={this.toggleDelConf}
      />
      :
      '';

    var pmntsOpt = [];
    for (var key in srvcs){
      if(srvcs.hasOwnProperty(key)) {
        if(
          (
            srvcs[key].srvc_type === -1 &&
            srvcs[key].srvc_active === 1
          ) ||
          srvcs[key].srvc_id === data.post_srvc_id
        ){
          pmntsOpt.push({value:srvcs[key].srvc_id,label:srvcs[key].srvc_desc});
        }
      }
    }
    pmntsOpt.sort(sortOpts);

    return (
      <tr>
        <td>
          <div className="form-group">
            <button  type="button" className="btn btn-success btn-xs"
              onClick={this.savePost}
              title="Сохранить"
            >
              <span className="glyphicon glyphicon-save"></span>
            </button>
          </div>
          <div className="form-group">
            <button type="button" className="btn btn-default btn-xs"
              onClick={this.props.cancelEdit}
              title="Отменить"
            >
              <span className="glyphicon glyphicon-remove"></span>
            </button>
          </div>
          <div className="form-group">
            <button type="button" className="btn btn-danger btn-xs"
              onClick={this.toggleDelConf}
              title="Удалить"
            >
              <span className="glyphicon glyphicon-trash"></span>
            </button>
          </div>
          {delConf}
        </td>
        <td>
          {pmntLinkOptions && (
            <div className="form-group">
              <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                <label>Проводка</label>&nbsp;
                <div style={{flex: 1, width: 0}}>
                  <Select
                    clearable={false}
                    options={pmntLinkOptions}
                    value={data.post_link}
                    onChange={this.updateLink}
                  />
                </div>
              </div>
            </div>
          )}
          <div className="form-group">
            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
              <label>Метод</label>&nbsp;
              <div style={{flex: 1, width: 0}}>
                <Select
                  clearable={false}
                  options={pmntsOpt}
                  value={data.post_srvc_id}
                  onChange={e => this.updateSelect(e,'post_srvc_id')}
                  autofocus
                />
              </div>
            </div>
          </div>
          <div className="form-group">
            <textarea type="text"
              className="form-control"
              name="post_desc"
              value={data.post_desc}
              rows="3"
              title="Описание"
              placeholder="Описание"
              onChange={this.updateInput}
            />
          </div>
          {errors.form && <div className="alert alert-danger">{errors.form}</div>}
        </td>
        <td className="form-group">
          <input type="text"
            className="form-control text-editable"
            value={data.post_price}
            name="post_price"
            onChange={this.updateInput}
          />
        </td>
        <td className="text-right">
          {data.post_qntt}
        </td>
        <td className="text-right">{fnum(data.post_price*data.post_qntt)}</td>
        <td colSpan="2">
          <div className="form-group">
            <label style={{cursor:'pointer',fontWeight:(data.post_payed?'bold':'normal')}}>
              Оплачено{" "}
              <input type="checkbox" checked={data.post_payed}
                name="post_payed" onChange={this.handleChBox} />
            </label>{" "}
            <span style={{cursor:'pointer',textDecoration:'underline'}}
              onClick={this.payedToday}>Сегодня</span>
          </div>
          <div className="form-group">
            <DatePicker
              className="form-control"
              showMonthDropdown
              showYearDropdown
              dropdownMode="select"
              selected={moment(data.post_bdate)}
              onChange={(e) => this.updateDate(e, 'post_bdate')}
              title="Дата оплаты"
            />
          </div>
        </td>
        <td>
          <div className="form-group">
            <textarea type="text"
              className="form-control"
              value={data.post_note}
              rows="3"
              placeholder="Заметка"
              title="Заметка"
              name="post_note"
              onChange={this.updateInput}
            />
          </div>
        </td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/prs/PRSEditPmntForm.js